export default __webpack_public_path__ + "static/media/webdev.09a09851.jpg";